import type { AxiosError } from "axios";

export const getAxiosErrorMessage = (error: AxiosError | null | undefined): string | undefined => {
  if (!error) return undefined;

  return error?.response?.data?.error;
};
